export const phoneTextFilter = (arr, textSearch) => {
  if (!textSearch) return arr;
  debugger;
  return arr.filter(product => product.title.includes(textSearch));
};
